import fetch from "common/js/fetch";

// 登录 http://sys.malldev.hichengdai.com/api/core/v1/user/login/sys
export function login(params) {
  return fetch("/core/v1/user/login/supplier", params);
}

// 获取手机验证码
export function getVerificationCode(mobile) {
  return fetch("/core/v1/sms_out/permission_none/sms_code", {
    mobile,
    bizType: "FORGET_LOGINPWD"
  });
}

// 修改登录密码
export function changePwd(params) {
  return fetch("/core/v1/user/forget_loginPwd", params);
}



// WEBPACK FOOTER //
// ./src/api/login.js